module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "el-tabs el-tabs--top el-tabs--border-card"
  }, [_c('div', {
    staticClass: "el-tabs__header is-top"
  }, [_c('div', {
    staticClass: "el-tabs__nav-wrap is-top"
  }, [_c('div', {
    staticClass: "el-tabs__nav-scroll flex-row-between"
  }, [_c('div', {
    staticClass: "el-tabs__nav is-top"
  }, _vm._l((_vm.navList.children), function(item) {
    return (!item.hidden) ? _c('div', {
      key: item.path,
      staticClass: "el-tabs__item is-top",
      class: {
        'is-active': item.path === _vm.$route.path
      },
      attrs: {
        "id": "modifyTab"
      },
      on: {
        "click": function($event) {
          return _vm.tabItemClick(item)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(item.name) + "\n                    ")]) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "MR-10"
  }, [_vm._t("append")], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "el-tabs__content"
  }, [_c('transition', {
    attrs: {
      "name": "el-fade-in-linear",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-2e95bfb2","transformToRequire":{"audio":"src"}}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/tab/Index.vue
// module id = 928
// module chunks = 116